import { Mail, Phone, MapPin, MessageCircle, Clock, User, Building2 } from "lucide-react";
import { WHATSAPP_DISPLAY, WHATSAPP_NUMBER } from "../lib/api";

import SEO from "../components/SEO";
export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-[#FBFCFA]">
      <SEO
        title="Contact RSN Gloves"
        description="Contact RSN Gloves for bulk quotations, product specifications, dealer enquiries and industrial hand glove requirements across India."
        path="/contact"
      />
      <section className="bg-white border-b border-[#DFE7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-14">
          <div className="section-kicker">Get in touch</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black text-[#0F172A] mt-2">Let's talk gloves.</h1>
          <p className="mt-3 max-w-xl text-[#5F6B66]">For bulk RFQs, product specifications, distribution enquiries and commercial requirements.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid md:grid-cols-3 gap-5">
          <ContactCard icon={Phone} title="Call / WhatsApp">
            <a href="tel:+918928341661" className="font-display text-2xl font-black text-[#0F172A] hover:text-[#075B3A]">{WHATSAPP_DISPLAY}</a>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello RSN Gloves")}`}
              target="_blank"
              rel="noreferrer"
              className="btn-whatsapp mt-5 w-fit"
            >
              <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
            </a>
          </ContactCard>

          <ContactCard icon={Mail} title="Email">
            <a href="mailto:ashish.arihantsales@gmail.com" className="font-display text-lg sm:text-xl font-black text-[#0F172A] hover:text-[#075B3A] break-all">ashish.arihantsales@gmail.com</a>
            <p className="text-sm text-[#5F6B66] mt-3">For RFQs, specifications and commercial documents.</p>
          </ContactCard>

          <ContactCard icon={User} title="Contact Person">
            <div className="font-display text-2xl font-black text-[#0F172A]">Ashish Agrawal</div>
            <p className="text-sm text-[#5F6B66] mt-2">Direct contact for bulk enquiries and partnerships.</p>
          </ContactCard>
        </div>

        <div className="grid lg:grid-cols-2 gap-5 mt-5">
          <ContactCard icon={Building2} title="Marketed By">
            <div className="font-display text-2xl font-black text-[#0F172A]">Arihant Welding & Safety</div>
            <p className="text-sm text-[#5F6B66] mt-3">Industrial safety and allied supplies, Nagpur.</p>
          </ContactCard>

          <ContactCard icon={MapPin} title="Office Address">
            <div className="font-semibold text-[#0F172A] leading-relaxed">Agrasen Chowk, Behind Pritam Hotel,<br />Gandhibagh, Nagpur, Maharashtra – 440032</div>
            <a href="https://maps.google.com/?q=Agrasen+Chowk+Gandhibagh+Nagpur" target="_blank" rel="noreferrer" className="inline-block mt-4 text-xs font-bold text-[#075B3A]">View on Google Maps →</a>
          </ContactCard>
        </div>
      </section>

      <section className="bg-[#EEF5F0] border-t border-[#DFE7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex items-center gap-3 text-sm">
          <Clock className="w-5 h-5 text-[#075B3A]" />
          <span className="font-bold text-[#0F172A]">Working Hours:</span>
          <span className="text-[#5F6B66]">Mon – Sat · 9:00 AM – 8:00 PM IST</span>
        </div>
      </section>
    </div>
  );
}

function ContactCard({ icon: Icon, title, children }) {
  return (
    <div className="soft-card p-7">
      <Icon className="w-7 h-7 text-[#075B3A]" strokeWidth={1.6} />
      <div className="text-xs font-bold uppercase tracking-[0.16em] text-[#6B7971] mt-5 mb-2">{title}</div>
      {children}
    </div>
  );
}
